<ng-container *ngIf="identificator !== 'panapark'; else panaparkHtml">
<app-header></app-header>
<mat-card class="content">
    <mat-card-content class="formpay">
        <form [formGroup]="basicForm" (ngSubmit)="send()">
            <h1>Completa tu metodo de pago</h1>
            <p>Detalles del pago</p>
            <img src="/assets/images/visa_mastercard.svg" alt="tarjeta de credito">
            <div class="form-row">

                <div class="form-column">

                    <div class="pb-16">

                        <mat-form-field class="full-width">
                            <mat-label>Titular</mat-label>
                            <input
                            matInput
                            name="nameHolderCreditCard"
                            formControlName="nameHolderCreditCard"
                            value="">
                        </mat-form-field>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('required') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Titular es requerido </small>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('invalidChars') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Solo letras, espacios y tildes permitidos </small>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('maxLength') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Máximo 50 caracteres </small>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('minWords') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Debe incluir nombre y apellido </small>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('firstWordShort') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> El nombre debe tener al menos 3 caracteres </small>
                        <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('lastWordShort') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> El apellido debe tener al menos 3 caracteres </small>

                    </div>

                    <div class="pb-16">

                        <mat-form-field class="full-width">
                            <mat-label> Año de Expiración </mat-label>
                            <mat-select [formControl]="basicForm.controls['expYearCreditCard']"  >
                                <mat-option *ngFor="let year of expirationYears" [value]="year.value">{{year.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small 
                        *ngIf="basicForm.controls['expYearCreditCard'].hasError('required') && basicForm.controls['expYearCreditCard'].touched" 
                        class="form-error-msg"> Año es requerido </small>

                    </div>


                    <div class="pb-16">
                        <mat-form-field class="full-width">
                        <mat-label>CCV</mat-label>
	                        <input 
	                            maxlength="4"
	                            type="password"
	                            name="ccv"
	                            matInput
	                            formControlName="ccv"
	                            inputmode="numeric"
	                            (keypress)="onlyNumberKey($event)"
	                            (input)="sanitizeOnlyNumbers($event)"
	                            value="">
	                        </mat-form-field>
	                        <small 
	                        *ngIf="basicForm.controls['ccv'].hasError('required') && basicForm.controls['ccv'].touched" 
	                        class="form-error-msg"> CCV es requerido </small>
	                        <small 
	                        *ngIf="basicForm.controls['ccv'].hasError('pattern') && basicForm.controls['ccv'].touched" 
	                        class="form-error-msg"> CCV debe tener 3 o 4 dígitos </small>
                    </div>

               

                    
                </div>

                <div class="form-column">
                    <div class="pb-16">
                        <mat-form-field class="full-width">
                            <mat-label>Tarjeta</mat-label>
	                            <input 
	                            (keypress)="onlyNumberKey($event)"
	                            (input)="formatCardNumber($event)"
	                            matInput
	                            name="numberCreditCard"
	                            maxlength="23"
	                            inputmode="numeric"
	                            formControlName="numberCreditCard">
	                        </mat-form-field>
	                        <small 
	                        *ngIf="basicForm.controls['numberCreditCard'].hasError('required') && basicForm.controls['numberCreditCard'].touched" 
	                        class="form-error-msg"> Tarjeta es requerido </small>
	                        <small 
	                        *ngIf="(basicForm.controls['numberCreditCard'].hasError('minlength') || basicForm.controls['numberCreditCard'].hasError('maxlength') || basicForm.controls['numberCreditCard'].hasError('pattern')) && basicForm.controls['numberCreditCard'].touched" 
	                        class="form-error-msg"> Número de tarjeta debe tener entre 15 y 19 dígitos </small>
	                        <small 
	                        *ngIf="basicForm.controls['numberCreditCard'].hasError('luhn') && basicForm.controls['numberCreditCard'].touched" 
	                        class="form-error-msg"> Número de tarjeta inválido </small>
                    </div>


                    <div class="pb-16">

                        <mat-form-field class="full-width">
                            <mat-label> Mes de Expiración </mat-label>
                            <mat-select [formControl]="basicForm.controls['expMonthCreditCard']"  >
                                <mat-option value="01" >ENERO</mat-option>
                                <mat-option value="02" >FEBRERO</mat-option>
                                <mat-option value="03" >MARZO</mat-option>
                                <mat-option value="04" >ABRIL</mat-option>
                                <mat-option value="05" >MAYO</mat-option>
                                <mat-option value="06" >JUNIO</mat-option>
                                <mat-option value="07" >JULIO</mat-option>
                                <mat-option value="08" >AGOSTO</mat-option>
                                <mat-option value="09" >SEPTIEMBRE</mat-option>
                                <mat-option value="10" >OCTUBRE</mat-option>
                                <mat-option value="11" >NOVIEMBRE</mat-option>
                                <mat-option value="12" >DICIEMBRE</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small 
                        *ngIf="basicForm.controls['expMonthCreditCard'].hasError('required') && basicForm.controls['expMonthCreditCard'].touched" 
                        class="form-error-msg"> Mes es requerido </small>
                        <small 
                        *ngIf="basicForm.hasError('expiredDate') && basicForm.controls['expMonthCreditCard'].touched && basicForm.controls['expYearCreditCard'].touched" 
                        class="form-error-msg"> La fecha de expiración ya ha pasado </small>

                    </div>

                </div>
            </div>


            <div class="form-actions">
                <button 
                mat-raised-button 
                [disabled]="basicForm.invalid ">Suscribirme</button>
            </div>
           
        </form>
    </mat-card-content>
</mat-card>

 <app-footer></app-footer>
</ng-container>

<ng-template #panaparkHtml>
    <section class="panapark-page">
        <header class="panapark-header">
            <div class="panapark-top">
                <br>
                <!-- <a href="tel:+507 3928100">+507 3928100</a> -->
            </div>
            <div class="panapark-brand">
                <img src="/assets/images/panapark/panapark-logo.svg" alt="PanaPark">
            </div>
        </header>

        <mat-card class="content panapark-content">
            <mat-card-content class="formpay panapark-formpay">
                <form [formGroup]="basicForm" (ngSubmit)="send()">
                    <h1>Completa tu metodo de pago</h1>
                    <p>Detalles del pago</p>
                    <img src="/assets/images/visa_mastercard.svg" alt="tarjeta de credito">
                    <div class="form-row">

                        <div class="form-column">

                            <div class="pb-16">

                                <mat-form-field class="full-width">
                                    <mat-label>Titular</mat-label>
                                    <input
                                    matInput
                                    name="nameHolderCreditCard"
                                    formControlName="nameHolderCreditCard"
                                    value="">
                                </mat-form-field>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('required') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Titular es requerido </small>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('invalidChars') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Solo letras, espacios y tildes permitidos </small>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('maxLength') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Máximo 50 caracteres </small>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('minWords') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> Debe incluir nombre y apellido </small>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('firstWordShort') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> El nombre debe tener al menos 3 caracteres </small>
                                <small *ngIf="basicForm.controls['nameHolderCreditCard'].hasError('lastWordShort') && basicForm.controls['nameHolderCreditCard'].touched" class="form-error-msg"> El apellido debe tener al menos 3 caracteres </small>

                            </div>

                            <div class="pb-16">

                                <mat-form-field class="full-width">
                                    <mat-label> Año de Expiración </mat-label>
                                    <mat-select [formControl]="basicForm.controls['expYearCreditCard']"  >
                                        <mat-option *ngFor="let year of expirationYears" [value]="year.value">{{year.label}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <small 
                                *ngIf="basicForm.controls['expYearCreditCard'].hasError('required') && basicForm.controls['expYearCreditCard'].touched" 
                                class="form-error-msg"> Año es requerido </small>

                            </div>


                            <div class="pb-16">
                                <mat-form-field class="full-width">
                                <mat-label>CCV</mat-label>
	                                <input 
	                                    maxlength="4"
	                                    type="password"
	                                    name="ccv"
	                                    matInput
	                                    formControlName="ccv"
	                                    inputmode="numeric"
	                                    (keypress)="onlyNumberKey($event)"
	                                    (input)="sanitizeOnlyNumbers($event)"
	                                    value="">
	                                </mat-form-field>
	                                <small 
	                                *ngIf="basicForm.controls['ccv'].hasError('required') && basicForm.controls['ccv'].touched" 
	                                class="form-error-msg"> CCV es requerido </small>
	                                <small 
	                                *ngIf="basicForm.controls['ccv'].hasError('pattern') && basicForm.controls['ccv'].touched" 
	                                class="form-error-msg"> CCV debe tener 3 o 4 dígitos </small>
                            </div>

                        </div>

                        <div class="form-column">
                            <div class="pb-16">
                                <mat-form-field class="full-width">
                                    <mat-label>Tarjeta</mat-label>
	                                    <input 
	                                    (keypress)="onlyNumberKey($event)"
	                                    (input)="formatCardNumber($event)"
	                                    matInput
	                                    name="numberCreditCard"
	                                    maxlength="23"
	                                    inputmode="numeric"
	                                    formControlName="numberCreditCard">
	                                </mat-form-field>
	                                <small 
	                                *ngIf="basicForm.controls['numberCreditCard'].hasError('required') && basicForm.controls['numberCreditCard'].touched" 
	                                class="form-error-msg"> Tarjeta es requerido </small>
	                                <small 
	                                *ngIf="(basicForm.controls['numberCreditCard'].hasError('minlength') || basicForm.controls['numberCreditCard'].hasError('maxlength') || basicForm.controls['numberCreditCard'].hasError('pattern')) && basicForm.controls['numberCreditCard'].touched" 
	                                class="form-error-msg"> Número de tarjeta debe tener entre 15 y 19 dígitos </small>
	                                <small 
	                                *ngIf="basicForm.controls['numberCreditCard'].hasError('luhn') && basicForm.controls['numberCreditCard'].touched" 
	                                class="form-error-msg"> Número de tarjeta inválido </small>
                            </div>


                            <div class="pb-16">

                                <mat-form-field class="full-width">
                                    <mat-label> Mes de Expiración </mat-label>
                                    <mat-select [formControl]="basicForm.controls['expMonthCreditCard']"  >
                                        <mat-option value="01" >ENERO</mat-option>
                                        <mat-option value="02" >FEBRERO</mat-option>
                                        <mat-option value="03" >MARZO</mat-option>
                                        <mat-option value="04" >ABRIL</mat-option>
                                        <mat-option value="05" >MAYO</mat-option>
                                        <mat-option value="06" >JUNIO</mat-option>
                                        <mat-option value="07" >JULIO</mat-option>
                                        <mat-option value="08" >AGOSTO</mat-option>
                                        <mat-option value="09" >SEPTIEMBRE</mat-option>
                                        <mat-option value="10" >OCTUBRE</mat-option>
                                        <mat-option value="11" >NOVIEMBRE</mat-option>
                                        <mat-option value="12" >DICIEMBRE</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <small 
                                *ngIf="basicForm.controls['expMonthCreditCard'].hasError('required') && basicForm.controls['expMonthCreditCard'].touched" 
                                class="form-error-msg"> Mes es requerido </small>
                                <small 
                                *ngIf="basicForm.hasError('expiredDate') && basicForm.controls['expMonthCreditCard'].touched && basicForm.controls['expYearCreditCard'].touched" 
                                class="form-error-msg"> La fecha de expiración ya ha pasado </small>

                            </div>

                        </div>
                    </div>

                    <div class="form-actions">
                        <button 
                        mat-raised-button 
                        [disabled]="basicForm.invalid ">Suscribirme</button>
                    </div>
                
                </form>
            </mat-card-content>
        </mat-card>

        <footer class="panapark-footer">
            <div class="panapark-footer-rights">
                <img src="/assets/images/panapark/panapark-logo.svg" alt="PanaPark">
                <span>{{ footerRightsText }}</span>
            </div>
        </footer>
    </section>
</ng-template>

<form id="formid" name="form" method="POST" >     
    <input type="hidden" id="Ds_SignatureVersion" name="Ds_SignatureVersion" value="HMAC_SHA256_V1"/>
    <input type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" value="{{jsonEncoded}}"/>
    <input type="hidden" id="Ds_Signature" name="Ds_Signature" value="{{signatureCalculated}}"/>	
 </form>
